import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, withProps } from 'recompose';
import { Modal } from 'antd';

import { CANCELLATION_NOTES_FORM_NAME as FORM_NAME } from '../../constants';

import TextArea from '../Fields/TextArea';

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};
const defaultProps = {
  isVisible: false,
};

const PlanCancellationNotesModal = ({
  isVisible,
  handleSubmit,
  onOk,
  onCancel,
}) => (
  <Modal
    title="Are you sure you want to cancel this plan?"
    visible={isVisible}
    onOk={handleSubmit(() => onOk())}
    onCancel={onCancel}
    okText="Yes"
    cancelText="No"
    destroyOnClose
  >
    <form>
      <Field
        name="notes"
        id="notes"
        label="Leave some notes here, if you wish"
        component={TextArea}
      />
    </form>
  </Modal>
);

PlanCancellationNotesModal.propTypes = propTypes;
PlanCancellationNotesModal.defaultProps = defaultProps;

export default compose(
  withProps(() => ({
    initialValues: {
      notes: null,
    },
  })),
  reduxForm({
    form: FORM_NAME,
  }),
)(PlanCancellationNotesModal);
